// Shared ±10% / cents-rounding constants for the price-estimation engine. The
// ±10% widening factor and the cents-rounding scale are reused by both the
// per-component widening helper (`widen.ts`) and the floor-dominated band
// rule (`calculate.ts`) so the displayed range is computed in one place.

export const WIDEN_MAX_FACTOR = 1.1;
export const WIDEN_MIN_FACTOR = 0.9;
export const CENTS_SCALE = 100;
